import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCompras } from 'services/servicioGet';
import { ListadoCompra } from 'utils/models/interfaces';

interface ComprasState {
  compras: ListadoCompra[];
  loadingCompras: boolean;
  errorCompras: string | null;
}

// Estado inicial del slice
const initialState: ComprasState = {
  compras: [],
  loadingCompras: false,
  errorCompras: null,
};

// Thunk para obtener las compras
export const fetchCompras = createAsyncThunk('compras/fetchCompras', async (_, { rejectWithValue }) => {
  try {
    const response = await getCompras();
    return response;
  } catch (error: unknown) {
    return rejectWithValue(error instanceof Error ? error.message : String(error));
  }
});

// Slice de compras
const comprasSlice = createSlice({
  name: 'compras',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCompras.pending, state => {
        state.loadingCompras = true;
        state.errorCompras = null;
      })
      .addCase(fetchCompras.fulfilled, (state, action) => {
        state.compras = action.payload;
        state.loadingCompras = false;
      })
      .addCase(fetchCompras.rejected, (state, action) => {
        state.loadingCompras = false;
        state.errorCompras = action.payload as string;
      });
  },
});

export default comprasSlice.reducer;
